// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-7bf84ac2]{background:#f0f0f0}.wrap[data-v-7bf84ac2]{word-break:break-all}.word[data-v-7bf84ac2]{word-break:normal}.display-4[data-v-7bf84ac2]{font-size:2.5rem!important;text-align:center!important}#address[data-v-7bf84ac2],#mnemonic[data-v-7bf84ac2],#pk[data-v-7bf84ac2]{font-family:Hack}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
